import { Container } from "@material-ui/core";
import useLanguageStore from "@stores/languageStore";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import SEOHead from "../../components/SEOHead";
import SectionHeader from "../../components/SectionHeader";
import { getCityBySlug } from "../../data/citiesData";

const CityLandingPage = () => {
	const { cityName } = useParams();
	const { t } = useTranslation();
	const { language } = useLanguageStore();
	const isRtl = language === "he";
	const city = getCityBySlug(cityName);

	if (!city) {
		return (
			<div
				className={`min-h-[calc(100vh-64px)] py-20 ${isRtl ? "rtl" : "ltr"}`}
			>
				<Container>
					<h1>{t("error.title")}</h1>
					<p>{t("error.message")}</p>
				</Container>
			</div>
		);
	}

	const cityDisplayName = city.name[language];
	const cemeteryNames =
		city.cemeteries.length > 0
			? city.cemeteries.map((c) => c[language]).join(" / ")
			: cityDisplayName;

	const metaTitle = t("cities.meta.title", { city: cityDisplayName });
	const metaDescription = t("cities.meta.description", {
		city: cityDisplayName,
	});
	const h1Text = t("cities.pageTitle", { city: cemeteryNames });

	return (
		<div
			className={`min-h-[calc(100vh-64px)] py-20 sm:py-32 max-w-[100vw] overflow-x-hidden ${
				isRtl ? "rtl" : "ltr"
			}`}
		>
			<SEOHead title={metaTitle} description={metaDescription} />
			<Container maxWidth="lg" className="px-4 sm:px-8">
				<SectionHeader title={h1Text} className="mb-12" titleWeight="800" component="h1" />

				<div
					className={`leading-relaxed text-base mb-8 ${isRtl ? "text-right" : "text-left"}`}
				>
					<p>{t("cities.content.intro", { city: cemeteryNames })}</p>
				</div>

				<h2
					className={`text-2xl font-bold mb-6 ${isRtl ? "text-right" : "text-left"}`}
				>
					{t("cities.whyChooseTitle", { city: cityDisplayName })}
				</h2>

				<ul className={`space-y-4 mb-8 ${isRtl ? "text-right" : "text-left"}`}>
					{[1, 2, 3, 4].map((num) => (
						<li key={num} className="flex items-start">
							<span className={`font-bold mr-2 ${isRtl ? "ml-2 mr-0" : ""}`}>
								{num}.
							</span>
							<span>
								{t(`cities.content.reasons.${num}`, { city: cemeteryNames })}
							</span>
						</li>
					))}
				</ul>
			</Container>
		</div>
	);
};

export default CityLandingPage;
